module.exports = __webpack_public_path__ + "static/Banner-26-4eb4bc0bada12eed16effbbbe82a119c.png";